"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgResentlyBuy = function SvgResentlyBuy(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#E6E9EE",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.197 5.927a2.013 2.013 0 1 0-.28-4.016 2.013 2.013 0 0 0 .28 4.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.09 8.329.533 4.47s.192 1.45.99 3.205c.718-.62 1.73-1.708 1.73-1.708s1.046-.842 1.699.074c.653.916-.547.87-.547.87l-2.77 2.314s-1.023.448-1.393-.635l-1.06-3.11s-.214-.553-.555-.507c-.34.046-.382.24-.405.78-.023.54-.049 4.436.013 5.854.063 1.419-.447 1.852-1.007 1.827-.56-.026-.356-1.255-.356-1.255l-.2-6.843-.392-5.542S8.35 8 7.518 6.36c-.83-1.64-1.257-2.513-1.257-2.513s-.446-1.079.178-1.425c.625-.346 1.172.746 1.172.746s1.317 3.328 2.137 3.574c1.445.202 3.15.188 3.15.188l2.11-.591-1.12-2.407s-.668-1.296.165-1.693c.833-.397 1.023.859 1.023.859l1.15 2.457s.31 1.374-.364 1.626c-.255.251-2.771 1.148-2.771 1.148Z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3c0 .167.1.7.5 1.5m16.5 2c0 .8-.667 1.667-1 2M18.5 2c-.167.167-.4.6 0 1M2 16c.333 0 1.1-.2 1.5-1M1 6.5c0 .4.333 1.167.5 1.5M7 10c-.167.333-.8 1-2 1m15.5 6c.5 0 1.6-.3 2-1.5m-5-4.5c.5-.167 1.6-.4 2 0"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgResentlyBuy);
var _default = exports["default"] = Memo;